import {
  Box,
  Flex,
  Spinner,
  Stack,
  Text,
  useMediaQuery
} from '@chakra-ui/react';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';

import FilterContext from '../../../../contexts/FilterContext';
import { apiSensedia } from '../../../../services/api-sensedia';
import { getDadosLogin } from '../../../../utils/dados-login.util';
import { PageSubHeaderLeadsKanbanGestor } from '../gestao/components/PageSubHeaderLeadsKanbanGestor';
import { KanbanDnd } from './partials/KanbanDnd';
import KanbanFilters from './partials/KanbanFilters';
import { KanbanMobile } from './partials/KanbanMobile';

export const KanbanLeads = ({ withPagination = false }: any): JSX.Element => {
  const isInitialMount = useRef(true);

  const [data, setData] = useState<any>({
    oportunidades: [],
    novoContato: [],
    emNegociacao: [],
    concluidos: [],
    naoAtendido: []
  });

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({
    quantidade_leads_totais: 0,
    quantidade_leads_visualizados: 0,
    quantidade_leads_nao_visualizados: 0,
    quantidade_leads_agendamento_em_atraso: 0,
    quantidade_leads_vendas_realizadas: 0,
    quantidade_leads_vendas_nao_realizadas: 0
  });

  const [isMobile] = useMediaQuery('(max-width: 920px)');
  // const [leads, setLeads] = useState([]);
  const [tipoUsuario, setTipoUsuario] = useState('vendedor');
  const [visualization] = useState('card');

  const { filterObject, setFiltersState, exportObject, setExportObject } =
    useContext(FilterContext);

  const getData = async () => {
    setLoading(true);
    const headers = filterObject?.headers?.login
      ? { headers: { login: filterObject?.headers?.login } }
      : {};

    try {
      const { data } = await apiSensedia.get(
        `oportunidades-sulamerica/painel-leads/leads/indicadores`,
        { ...headers }
      );

      setValues({ ...data });

      const dadosLogin = await getDadosLogin();

      setTipoUsuario(dadosLogin?.isManager ? 'gestor' : 'vendedor');
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
    }

    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [data, filterObject]);

  return (
    <>
      <PageSubHeaderLeadsKanbanGestor
        title="Painel de Gestão de Leads"
        isGestor={tipoUsuario === 'gestor'}
      />
      {visualization === 'card' && (
        <Stack
          w="100%"
          spacing={23}
          display="flex"
          justify="center"
          align="center"
          // mt={!isMobile ? '0' : '1rem'}
          mt={'1rem'}
        >
          {!isMobile ? (
            <>
              <Box
                display="flex"
                w="97vw"
                alignItems="center"
                justifyContent="center"
              >
                <Box
                  w="21.5vw"
                  boxShadow="0px 0px 5px rgba(50, 50, 50, 0.1)"
                  h={!isMobile ? '17vh' : ' 13vh'}
                  bg={'#fff'}
                  border={'0'}
                  borderRadius="0.8rem"
                  display="flex"
                  pb="2vh"
                  alignItems="center"
                  justifyContent="center"
                  flexDir="column"
                  mr={!isMobile ? '24px' : '10px'}
                >
                  <Text
                    fontWeight="bold"
                    color={'gray.900'}
                    fontSize={!isMobile ? '7vh' : ' 5vh'}
                  >
                    {!loading ? (
                      values.quantidade_leads_nao_visualizados
                    ) : (
                      <Flex w="100%" justify="center">
                        <Spinner />
                      </Flex>
                    )}
                  </Text>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text
                      fontSize={!isMobile ? '2.5vh' : ' 1.5vh'}
                      color={'gray.900'}
                      align="center"
                    >
                      Leads sem visualização
                    </Text>
                  </Box>
                </Box>
                <Box
                  w={!isMobile ? '21.5vw' : '30vw'}
                  h={!isMobile ? '17vh' : ' 13vh'}
                  bg="#fff"
                  boxShadow="0px 0px 5px rgba(50, 50, 50, 0.1)"
                  borderRadius="0.8rem"
                  display="flex"
                  pb="2vh"
                  alignItems="center"
                  justifyContent="center"
                  flexDir="column"
                  mr={!isMobile ? '24px' : '10px'}
                >
                  <Text fontWeight="bold" fontSize={!isMobile ? '7vh' : ' 5vh'}>
                    {!loading ? (
                      values.quantidade_leads_agendamento_em_atraso
                    ) : (
                      <Flex w="100%" justify="center">
                        <Spinner />
                      </Flex>
                    )}
                  </Text>
                  <Text
                    fontSize={!isMobile ? '2.5vh' : ' 1.4vh'}
                    align="center"
                  >
                    Leads agendamento em atraso
                  </Text>
                </Box>
                <Box
                  w={!isMobile ? '21.5vw' : '30vw'}
                  h={!isMobile ? '17vh' : ' 13vh'}
                  boxShadow="0px 0px 5px rgba(50, 50, 50, 0.1)"
                  bg="#fff"
                  borderRadius="0.8rem"
                  display="flex"
                  pb="2vh"
                  alignItems="center"
                  justifyContent="center"
                  flexDir="column"
                >
                  <Text fontWeight="bold" fontSize={!isMobile ? '7vh' : ' 5vh'}>
                    {!loading ? (
                      values.quantidade_leads_vendas_realizadas
                    ) : (
                      <Flex w="100%" justify="center">
                        <Spinner />
                      </Flex>
                    )}
                  </Text>
                  <Text
                    fontSize={!isMobile ? '2.5vh' : ' 1.5vh'}
                    align="center"
                  >
                    Vendas realizadas
                  </Text>
                </Box>
                <Box
                  w={!isMobile ? '21.5vw' : '30vw'}
                  h={!isMobile ? '17vh' : ' 13vh'}
                  bg="#fff"
                  borderRadius="0.8rem"
                  display="flex"
                  alignItems="center"
                  boxShadow="0px 0px 5px rgba(50, 50, 50, 0.1)"
                  justifyContent="center"
                  flexDir="column"
                  pb="2vh"
                  ml={!isMobile ? '24px' : '10px'}
                >
                  <Text fontWeight="bold" fontSize={!isMobile ? '7vh' : ' 5vh'}>
                    {!loading ? (
                      values.quantidade_leads_vendas_nao_realizadas
                    ) : (
                      <Flex w="100%" justify="center">
                        <Spinner />
                      </Flex>
                    )}
                  </Text>
                  <Text
                    fontSize={!isMobile ? '2.5vh' : ' 1.5vh'}
                    align="center"
                  >
                    Vendas não realizadas
                  </Text>
                </Box>
              </Box>
              <KanbanFilters
                login={
                  filterObject?.headers?.login
                    ? filterObject?.headers?.login
                    : undefined
                }
              />
              <KanbanDnd />
            </>
          ) : (
            <>
              <div className="tw-w-full tw-flex tw-justify-between tw-px-4 tw-gap-4 tw-text-[#323232]">
                <div className="tw-bg-white tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[9.75rem] tw-rounded-lg tw-shadow-md">
                  <span className="tw-text-[2rem] tw-font-bold">
                    {!loading ? (
                      values.quantidade_leads_nao_visualizados
                    ) : (
                      <div className="tw-w-full tw-flex tw-justify-center">
                        <Spinner />
                      </div>
                    )}
                  </span>
                  <span className="tw-text-[0.9rem]">
                    Leads sem visualização
                  </span>
                </div>
                <div className="tw-bg-white tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[9.75rem] tw-rounded-lg tw-shadow-md">
                  <span className="tw-text-[2rem] tw-font-bold">
                    {!loading ? (
                      values.quantidade_leads_agendamento_em_atraso
                    ) : (
                      <div className="tw-w-full tw-flex tw-justify-center">
                        <Spinner />
                      </div>
                    )}
                  </span>
                  <span className="tw-text-[1rem] tw-text-center">
                    Leads agendamento <br /> em atraso
                  </span>
                </div>
              </div>
              <div className="tw-w-full tw-flex tw-justify-between tw-px-4 tw-gap-4 tw-text-[#323232]">
                <div className="tw-bg-white tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[9.75rem] tw-rounded-lg tw-shadow-md">
                  <span className="tw-text-[2rem] tw-font-bold">
                    {!loading ? (
                      values.quantidade_leads_vendas_realizadas
                    ) : (
                      <div className="tw-w-full tw-flex tw-justify-center">
                        <Spinner />
                      </div>
                    )}
                  </span>
                  <span className="tw-text-[1rem]">Vendas realizadas</span>
                </div>
                <div className="tw-bg-white tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[9.75rem] tw-rounded-lg tw-shadow-md">
                  <span className="tw-text-[2rem] tw-font-bold">
                    {!loading ? (
                      values.quantidade_leads_vendas_nao_realizadas
                    ) : (
                      <div className="tw-w-full tw-flex tw-justify-center">
                        <Spinner />
                      </div>
                    )}
                  </span>
                  <span className="tw-text-[1rem]">Vendas não realizadas</span>
                </div>
              </div>
              <KanbanMobile />
            </>
          )}
        </Stack>
      )}
    </>
  );
};
